export const GUIDED_TOUR = "Tour";
export const VIRTUAL_TOUR = "Virtual Tour";
export const APP_GUIDED_TOUR = "App Guided Tour";
export const SELF_GUIDED_TOUR = "Self Guided";
export const CONTACT_ME_TOUR = "Contact Me";
export const STD_ERROR_MSG = "SOMETHING ISN'T RIGHT. PLEASE CHECK TO MAKE SURE YOU HAVE COMPLETED THE FORM CORRECTLY.";

export const guestInfoFields: Map<string, string> = new Map<string, string>();
guestInfoFields.set("firstName", "First Name");
guestInfoFields.set("lastName", "Last Name");
guestInfoFields.set("email", "Email Address");
guestInfoFields.set("phone", "Phone Number");
guestInfoFields.set("bedrooms", "Number of Bedrooms");
guestInfoFields.set("bathrooms", "Number of Bathrooms");
guestInfoFields.set("tourType", "Tour Type");
guestInfoFields.set("tourTime", "Tour Time");
guestInfoFields.set("tourDate", "Tour Date");
guestInfoFields.set("moveInDate", "Move-In Date");

export const attributionList = [
"ApartmentList.com" ,
"Apartmentlist.com Plus"  ,
"Apartments.com/ApartmentFinder.com" ,
"Apple Maps" ,
"Bing" ,
"Corporate Housing" ,
"Craigslist" ,
"Drive By/Outdoor Signage" ,
"Email campaign" ,
"Employee Housing" ,
"Facebook" ,
"Fliers/Direct Mailer/Coupon" ,
"Good Gatherings/Events" ,
"Google AdWords" ,
"Google Business Listing" ,
"Google Organic" ,
"In-House Transfer" ,
"Instagram" ,
"Neighbor Referral" ,
"Other" ,
"Prior Neighbor Referral" ,
"Property Referral" ,
"Redfin/Rent.com/ApartmentGuide" ,
"Relocator Services/Referral Relators" ,
"University Referral" ,
"Yelp" ,
"Zillow/Trulia/Hotpads" ,
"Zumper/PadMapper" ,
"Zillow" ,
"Website/Prometheusreg.com" ,
"Website/PrometheusApartments.com"
];